import React, { useState, useEffect } from "react";
import { Button, DatePicker, Input, Select, Switch } from "antd";
import moment from "moment";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import useUserData from "../../../../../hooks/useUserData";
import UnitWithInput from "../../../../../components/UnitWithInput";
import {
  currentUnits,
  pressureUnits,
  speedUnits,
  temperatureUnits,
  volumeUnits,
} from "../../../../../Data/data";

// Map parameter names to labels and unit options
const parameterConfig = {
  suctionpressure: { label: "Suction Pressure", unitList: pressureUnits },
  dischargepressure: { label: "Discharge Pressure", unitList: pressureUnits },
  interstagepressure: { label: "Interstage Pressure", unitList: pressureUnits },
  lubeoilpressure: { label: "Lube Oil Pressure", unitList: pressureUnits },
  oilseparatorpressure: { label: "Oil Separator Pressure", unitList: pressureUnits },
  suctiontemperature: { label: "Suction Temperature", unitList: temperatureUnits },
  dischargetemperature: { label: "Discharge Temperature", unitList: temperatureUnits },
  superheattemperature: { label: "Superheat Temperature", unitList: temperatureUnits },
  coolingwaterinlettemperature: {
    label: "Cooling Water Inlet Temperature",
    unitList: temperatureUnits,
  },
  coolingwateroutlettemperature: {
    label: "Cooling Water Outlet Temperature",
    unitList: temperatureUnits,
  },
  seawatertemperature: { label: "Sea Water Temperature", unitList: temperatureUnits },
  motorbearingtemperature: { label: "Motor Bearing Temperature", unitList: temperatureUnits },
  refrigerantflowrate: { label: "Refrigerant Flow Rate", unitList: [] },
  vaporreturnflowrate: { label: "Vapor Return Flow Rate", unitList: [] },
  coolingwaterflowrate: { label: "Cooling Water Flow Rate", unitList: [] },
  motorvoltage: { label: "Motor Voltage", unitList: currentUnits },
  motorcurrent: { label: "Motor Current", unitList: currentUnits },
  powerconsumption: { label: "Power Consumption", unitList: [] },
  compressorspeedrpm: { label: "Compressor Speed (RPM)", unitList: speedUnits },
  lubeoillevel: { label: "Lube Oil Level", unitList: [] },
  runninghourstoday: { label: "Running Hours Today", unitList: [] },
  totalrunninghours: { label: "Total Running Hours", unitList: [] },
  operation: { label: "Operation", unitList: [] },
  operationhours: { label: "Operation Hours", unitList: [] },
  totaloperationhours: { label: "Total Operation Hours", unitList: [] },
};

export const LpgCargoCom = ({ eng_log_basic_id, _items }) => {
  const user = useUserData();
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    logDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    parameters: {},
    otherParams: {},
  });
  const [checked, setChecked] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  useEffect(() => {
  
    const initialParameters = (_items?.selected_parameters || []).reduce((acc, param) => {
      if (parameterConfig[param]) {
        acc[param] = { value: "", unit: parameterConfig[param].unitList[0] || "" };
      }
      return acc;
    }, {});

    const initialOtherParams = (_items?.other_parameters || []).reduce((acc, param) => {
      acc[param.name] = { value: param.value || "", unit: param.unit || "" };
      return acc;
    }, {});


    setFormData((prev) => ({
      ...prev,
      parameters: initialParameters,
      otherParams: initialOtherParams,
    }));

      VIEW_IGG_LOGBOOK_API(_items.id);
    
  }, [_items?.id]);

  // Handle date/time change
  const onChangeDateTime = (value) => {
    setFormData((prev) => ({
      ...prev,
      logDate: value ? value.format("YYYY-MM-DD HH:mm:ss") : null,
    }));
  };

  // Handle parameter value/unit change
  const updateParameter = (param, field, value) => {
    setFormData((prev) => ({
      ...prev,
      parameters: {
        ...prev.parameters,
        [param]: { ...prev.parameters[param], [field]: value },
      },
    }));
  };

  // Handle other parameter value/unit change
  const updateOtherParam = (name, field, value) => {
    setFormData((prev) => ({
      ...prev,
      otherParams: {
        ...prev.otherParams,
        [name]: { ...prev.otherParams[name], [field]: value },
      },
    }));
  };


  // API to view logbook details
  const VIEW_IGG_LOGBOOK_API = async (lpg_id, staff_dashboard) => {
    setLoader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("lpg_id", lpg_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      post(ApiURL.edit_view_lpg_info_machinery_com, FORM_DATA).then((res) => {
        setLoader(false);

        if (res?.status === true) {
          const lpgData = res?.response_data;
          setUpdateStatus(lpgData?.complete_status || false);
          // setSubmitStatus(lpgData?.submit_status || false);
          setSubmitStatus(true);

          setChecked(lpgData?.lpg_on_off || false);

          const parameters = Object.keys(lpgData?.selected_parameters || {}).reduce(
            (acc, param) => {
              const paramData = lpgData.selected_parameters[param] || { value: 0, unit: "" };
              acc[param] = {
                value: paramData.value !== undefined ? paramData.value.toString() : "0",
                unit: paramData.unit || parameterConfig[param]?.unitList[0] || "",
              };
              return acc;
            },
            {}
          );

          setFormData((prev) => {

            return {
              ...prev,
              logDate: lpgData?.date_time_log || moment().format("YYYY-MM-DD HH:mm:ss"),
              parameters,

              otherParams:
                lpgData?.other_parameters && Object.keys(lpgData.other_parameters).length
                  ? Object.keys(lpgData.other_parameters).reduce((acc, key) => {
                      const paramData = lpgData.other_parameters[key] || { value: "", unit: "" };
                      acc[key] = {
                        value: paramData.value !== undefined ? paramData.value.toString() : "",
                        unit: paramData.unit || "",
                      };
                      return acc;
                    }, {})
                  : prev.otherParams,
            };
          });
        } else {
          setErrors(res?.errors || {});
          ErrorToast("Error", "Failed to fetch logbook details.");
        }
      });
    } catch (error) {
      setLoader(false);
      console.error("Error fetching IGG logbook:", error);
      ErrorToast("Error", "An error occurred while fetching logbook details.");
    }
  };


  // Render
  return (
    <>
      <div className="row custom-box">
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>LPG name: {_items?.lpg_name}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>LPG Model: {_items?.lpg_maker}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>LPG Maker: {_items?.lpg_model}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>LPG id: {_items?.id}</b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            // onChange={(value) => {
            //   setChecked(value);
            //   updateStatus
            //     ? UPDATE_IGG_LOGBOOK_API(_items?.id, "0", value)
            //     : ADD_IGG_LOGBOOK_API(_items?.id, value);
            // }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {/* Date & Time */}
          <div className="row">
            <div className="col-4">
              <div className="input-box">
                <label>Date & Time</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="Select Date & Time"
                  value={formData.logDate ? moment(formData.logDate, "YYYY-MM-DD HH:mm:ss") : null}
                  onChange={onChangeDateTime}
                  style={{ width: "100%" }}
                  disabled={submitStatus}
                  className="custom-input"
                />
                {errors.date_time_log && <p className="error-text">{errors.date_time_log}</p>}
              </div>
            </div>
          </div>

          {/* Selected Parameters */}
          {(() => {
            const rows = [];
            const inputs = (_items?.selected_parameters || [])
              .filter((param) => parameterConfig[param])
              .map((param) => ({
                type: "selectedParam",
                name: param,
                config: parameterConfig[param],
                value: formData.parameters[param]?.value || "",
                unit: formData.parameters[param]?.unit || "",
              }));

            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`param-row-${i}`}>
                  {group.map((input) => (
                    <div className="col-4" key={input.name}>
                      {input.config.dropdownOptions ? (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Select
                            disabled={submitStatus}
                            value={input.value}
                            onChange={(value) => updateParameter(input.name, "value", value)}
                            className="custom-input"
                            style={{ width: "100%" }}
                            placeholder={`Select ${input.config.label}`}
                          >
                            {input.config.dropdownOptions.map((option) => (
                              <Select.Option key={option} value={option}>
                                {option}
                              </Select.Option>
                            ))}
                          </Select>
                          {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`] && (
                            <p className="error-text">
                              {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]}
                            </p>
                          )}
                        </div>
                      ) : input.config.unitList?.length ? (
                        <UnitWithInput
                          label={input.config.label}
                          value={input.value}
                          onChange={(e) => updateParameter(input.name, "value", e.target.value)}
                          unit={input.unit}
                          onUnitChange={(e) => updateParameter(input.name, "unit", e.target.value)}
                          disabled={submitStatus}
                          error={
                            errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]
                          }
                          unitList={input.config.unitList}
                          className="custom-input"
                        />
                      ) : (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Input
                            disabled={submitStatus}
                            value={input.value}
                            placeholder={input.config.label}
                            onChange={(e) => updateParameter(input.name, "value", e.target.value)}
                            className={`custom-input ${
                              errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]
                                ? "error"
                                : ""
                            }`}
                          />
                          {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`] && (
                            <p className="error-text">
                              {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-param-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          {/* Other Parameters */}
          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(formData.otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) => updateOtherParam(name, "value", e.target.value)}
                        unit={unit}
                        onUnitChange={(e) => updateOtherParam(name, "unit", e.target.value)}
                        disabled={submitStatus}
                        unitList={[unit]}
                        className="custom-input"
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-other-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

        </>
      )}
    </>
  );
};
